<template>
  <div class="NotificationSnackbarComponentWrapper" @click="handleAction">
    <div class="visual">
      <img v-if="picture" class="picture" :src="picture" />
    </div>
    <div class="content">
      <div class="text">
        <span v-if="sender"
          ><b>{{ sender }}</b></span
        >
        <span v-if="message">{{ message }}</span>
      </div>
      <span class="time preWrap">{{ $t("shared.snackbar.time") }}</span>
    </div>
  </div>
</template>

<script>
import notif_action_mixin from "~/components/notification/actions.js"

export default {
  props: {
    picture: {
      type: String,
      required: false,
    },
    sender: {
      type: String,
      required: false,
    },
    message: {
      type: String,
      required: false,
    },
    notification: {
      type: Object,
      required: false,
    },
  },
  methods: {
    handleAction: function () {
      var fn = notif_action_mixin.methods[this.notification.context.action]

      if (typeof fn === "function") {
        fn = fn.bind(this)
        fn({ notification: this.notification })
      }
    },
  },
}
</script>

<style scoped src="./notificationTemplate.css"></style>
<style scoped src="./notificationTemplate720.css"></style>
